/**
 * Validación matemática de CUIT/CUIL (módulo 11, AFIP) — espejo del server
 * (src/common/validation/cuitCheckDigit.ts en jupiter-server): pesos
 * 5,4,3,2,7,6,5,4,3,2 sobre los 10 primeros dígitos; dv = 11 − (suma mod 11),
 * con 11→0 y 10→inválido. Acepta máscara con guiones y la variante de 10
 * dígitos (DNI de 7 cifras: zero-pad del tramo central). El server es la
 * autoridad; esto es UX.
 */
export const isValidCuitCuil = (raw: string | null | undefined): boolean => {
  const digits = (raw ?? "").replace(/\D/g, "");
  if (digits.length !== 10 && digits.length !== 11) return false;
  const full =
    digits.length === 10 ? digits.slice(0, 2) + "0" + digits.slice(2) : digits;
  const weights = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  const sum = weights.reduce((acc, w, i) => acc + w * Number(full[i]), 0);
  const mod = sum % 11;
  const dv = mod === 0 ? 0 : 11 - mod;
  if (dv === 10) return false;
  return dv === Number(full[10]);
};
